import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {LabelsService} from "../../../labels/services/labels-service.service";


export class BringozLabelsComponent implements IController {
  labels: any;
  onChange: Function;

  labelOptions: any;
  labelChips: any;
  filterSelected: boolean = true;


  constructor(private $log, private labelsService: LabelsService) {
  }

  $onInit() {
    this.loadLabels();
  }

  $onChanges(changes) {
    if (changes.labels && !changes.labels.isFirstChange()) {
      if (this.labelOptions) {
        this.labelChips = this.getLabelChips(this.labels);
      }
    }
  }

  querySearch(string) {
    string = _.toLower(string);
    return string ? _.filter(this.labelOptions, function (l) {
      let labelLowerCaseName = _.toLower(l.name);
      return _.includes(labelLowerCaseName, string)
    }) : this.labelOptions;
  }

  onModelChange(labelChips) {
    let labels = _.map(labelChips, function (l) {
      return l.name
    });
    labels = _.uniq(labels);
    this.$log.info(labels);
    this.onChange({labels: labels})
  }


  private loadLabels() {
    this.labelsService.getAll()
      .then((labels) => {
        this.labelOptions = labels;
        this.labelChips = this.getLabelChips(this.labels);
      })
      .catch((error) => {
      })
  }

  private getLabelChips(labels) {
    return _.map(labels, (l) => {
      let labelChip = {
        name: l,
        _lowername: null
      };
      labelChip._lowername = l.toLowerCase();
      return labelChip;
    });
  }
}


angular
  .module('bringoz.admin.commons')
  .component('bringozLabels', {
    bindings: {
      labels: '<',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-labels/bringoz-labels.html',
    controller: BringozLabelsComponent
  });
